// import { BrowserRouter } from "react-router-dom";
import Navbar from "./components/Navbar";

function App() {
  return (
    // <BrowserRouter>
      <Navbar />
    // </BrowserRouter>
  );
}

export default App;

 {/*<Router>
        <nav className="bg-white border-b shadow-md">
      <div className="max-w-screen-xl mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-center">
          <p href="#" className="text-lg font-semibold text-blue-gray-900">
          <Link className="navbar-brand" to="/home">AMAHAN</Link>
          </p>
        </div>
        <div className="hidden lg:flex space-x-6">
          <p href="#" className="text-blue-gray-900 hover:text-blue-500 transition-colors">
            <Link className="nav-link active" aria-current="page" to="/home"> Home</Link>
          </p>
          {!isAuth ? 
          <p href="#" className="text-blue-gray-900 hover:text-blue-500 transition-colors">
          <Link className="nav-link active" aria-current="page" to="/signup">Login</Link>
          </p>
          :
          <><p href="#" className="text-blue-gray-900 hover:text-blue-500 transition-colors">
          <Link className="nav-link active" aria-current="page" onClick={signUserOut}>SignOut</Link>
          </p>
          <p href="#" className="text-blue-gray-900 hover:text-blue-500 transition-colors">
          <Link className="nav-link active" aria-current="page" to="/posts">Post</Link>
          </p>
          </>
          }
        </div>
        <div className="lg:hidden">
          <button
            className="text-blue-gray-900"
            onClick={() => setIsOpen(!isOpen)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        </div>
      </div>
      {isOpen && (
        <div className="lg:hidden bg-white shadow-md border-t">
          <div className="px-4 py-2 space-y-2">
            <p className="block text-blue-gray-900 hover:text-blue-500 transition-colors">
            <Link className="nav-link active" aria-current="page" to="/home"> Home</Link>
            </p>
            {!isAuth ?
            <p className="block text-blue-gray-900 hover:text-blue-500 transition-colors">
            <Link className="nav-link active" aria-current="page" to="/signup">Login</Link>
            </p>
            :<>
            <p className="block text-blue-gray-900 hover:text-blue-500 transition-colors">
            <Link className="nav-link active" aria-current="page" onClick={signUserOut}>SignOut</Link>
            </p>
            <p className="block text-blue-gray-900 hover:text-blue-500 transition-colors">
            <Link className="nav-link active" aria-current="page" to="/posts">Post</Link>
            </p>
            </>}
          </div>
        </div>
      )}
    </nav> */}

  {/* <Link className="navbar-brand" to="/home">AMAHAN</Link>
    
      <Link className="nav-link active" aria-current="page" to="/home">home</Link>
    
      {!isAuth ? <Link className="nav-link active" aria-current="page" to="/signup">Login</Link> 
        :
        <>
        <Link className="nav-link active" aria-current="page" onClick={signUserOut}>SignOut</Link>
        <Link className="nav-link active" aria-current="page" to="/posts">Post</Link>
        </>

      } */}
      
      {/* <Routes>
        <Route path='/profile' element={<Profile/>}/>
        <Route path="/blogdescription/:id" element={<BlogDescription isAuth={isAuth}/>}/>
        <Route path='/home' element={<Home isAuth={isAuth}/>}/>
        <Route path='/' element={<LoginPage setIsAuth={setIsAuth} />}/>
        <Route path='/posts' element={<Post isAuth={isAuth}/>}/>
      </Routes> */}
    {/* </Router> */}







//     rules_version = '2';

// service cloud.firestore {
//   match /databases/{database}/documents {

//     // This rule allows anyone with your Firestore database reference to view, edit,
//     // and delete all data in your Firestore database. It is useful for getting
//     // started, but it is configured to expire after 30 days because it
//     // leaves your app open to attackers. At that time, all client
//     // requests to your Firestore database will be denied.
//     //
//     // Make sure to write security rules for your app before that time, or else
//     // all client requests to your Firestore database will be denied until you Update
//     // your rules
//     match /{document=**} {
//       allow read, write: if request.time < timestamp.date(2026, 12, 12);
//     }
//   }
// }





// rules_version = '2';

// service cloud.firestore {
//   match /databases/{database}/documents {

//     // PUBLIC: Allow anyone to read blogs and comments
//     match /blogs/{blogId} {
//       allow read: if true;

//       // Only authenticated users can create or edit their own blogs
//       allow write: if request.auth != null && request.auth.uid == resource.data.authorId;
//     }

//     // COMMENTS: Anyone can read comments, only authenticated users can create
//     match /comments/{commentId} {
//       allow read: if true;

//       allow create: if request.auth != null;

//       // User can update/delete ONLY their own comment
//       allow update, delete: if request.auth != null
//                             && request.auth.uid == resource.data.userId;
//     }
//   }
// }